module.exports = __webpack_public_path__ + "static/media/Subtract.52b69cb1.svg";